export var CALL_CENTER_DIALOG_PAGE_KEY = 'call-center-dialog';